import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'sonner';
import { AuthProvider, useAuth } from '@/context/AuthContext';
import Login from '@/pages/Login';
import Register from '@/pages/Register';
import DashboardHome from '@/pages/DashboardHome';
import NewAnalysis from '@/pages/NewAnalysis';
import AnalysisResult from '@/pages/AnalysisResult';
import BusinessProfiles from '@/pages/BusinessProfiles';
import BatchComparison from '@/pages/BatchComparison';
import UniversalSearch from '@/pages/UniversalSearch';
import PlaceDetail from '@/pages/PlaceDetail';
import PointComparison from '@/pages/PointComparison';
import MLPredictor from '@/pages/MLPredictor';
import FieldChecklist from '@/pages/FieldChecklist';
import AdminPanel from '@/pages/AdminPanel';
import Layout from '@/components/Layout';
import '@/index.css';

const Protected = ({ children, adminOnly = false }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-slate-500">Cargando…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== 'admin') return <Navigate to="/" replace />;
  return children;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/" element={<Protected><Layout /></Protected>}>
            <Route index element={<DashboardHome />} />
            <Route path="analyses/new" element={<NewAnalysis />} />
            <Route path="analyses/:id" element={<AnalysisResult />} />
            <Route path="profiles" element={<BusinessProfiles />} />
            <Route path="batches/:batchId" element={<BatchComparison />} />
            <Route path="search" element={<UniversalSearch />} />
            <Route path="search/place/:id" element={<PlaceDetail />} />
            <Route path="compare" element={<PointComparison />} />
            <Route path="compare/:id" element={<PointComparison />} />
            <Route path="predict" element={<MLPredictor />} />
            <Route path="field" element={<FieldChecklist />} />
            <Route path="field/:id" element={<FieldChecklist />} />
            <Route path="admin" element={<Protected adminOnly><AdminPanel /></Protected>} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
